import { render, staticRenderFns } from "./ipt-single.vue?vue&type=template&id=94b036d6&scoped=true&"
import script from "./ipt-single.vue?vue&type=script&lang=ts&"
export * from "./ipt-single.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-single.vue?vue&type=style&index=0&id=94b036d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b036d6",
  null
  
)

export default component.exports